import React from 'react';

const formatCurrency = (value) => {
  if (!value) return '';
  return new Intl.NumberFormat('es-CO').format(value);
};

function Step7({ formData, errors, onChange, cargos, centrosCosto = [] }) {

  const hoy = new Date();

  const fechaMin = new Date(hoy);
  fechaMin.setDate(hoy.getDate() - 6);

  const fechaMax = new Date(hoy);
  fechaMax.setDate(hoy.getDate() + 6);

  const formatoFecha = (fecha) => fecha.toISOString().split("T")[0];

  return (
    <div className="step-panel">

      {/* LISTA DESPLEGABLE FILTRADA POR LA EMPRESA AUTENTICADA */}
      <div className="field-group">
        <label htmlFor="centroCosto">
          Nombre de la Obra o Centro de Costo <span className="required">*</span>
        </label>
        
        <select
          id="centroCosto"
          name="centroCosto"
          value={formData.centroCosto}
          onChange={onChange}
          className={errors.centroCosto ? 'error-field' : ''}
        >
          <option value="">Seleccione el proyecto o centro de costo...</option>
          {centrosCosto.map((proyecto) => (
            <option key={proyecto.id} value={proyecto.nombre}>
              {proyecto.nombre}
            </option>
          ))}
        </select>

        {errors.centroCosto && (<span className="field-error"> {errors.centroCosto}</span>)}
      </div>
      
      {/* FRENTE DE LA OBRA */}
      <div className="field-group">
        <label htmlFor="frenteObra">
          Frente de la Obra <span className="required">*</span>
        </label>
        <input
          id="frenteObra"
          name="frenteObra"
          type="text"
          value={formData.frenteObra}
          onChange={onChange}
          placeholder="Ingrese el frente de la obra"
          className={errors.frenteObra ? 'error-field' : ''}
        />
        {errors.frenteObra && <span className="field-error">{errors.frenteObra}</span>}
      </div>

      {/* CARGO */}
      <div className="field-group">
        <label htmlFor="cargo">
          Cargo <span className="required">*</span>
        </label>

        <select
          id="cargo"
          name="cargo"
          value={formData.cargo}
          onChange={onChange}
          className={errors.cargo ? 'error-field' : ''}
        >
          <option value="">Seleccione un cargo...</option>
          {cargos.map((cargo) => (
            <option key={cargo.id} value={cargo.nombre}>
              {cargo.nombre}
            </option>
          ))}
        </select>

        {errors.cargo && (
          <span className="field-error">{errors.cargo}</span>
        )}
      </div>

      {/* TIPO DE CONTRATO */}
      <div className="field-group">
        <label htmlFor="tipoContrato">
          Tipo de Contrato a Suscribir <span className="required">*</span>
        </label>
        <select
          id="tipoContrato"
          name="tipoContrato"
          value={formData.tipoContrato || ''}
          onChange={onChange}
          className={errors.tipoContrato ? 'error-field' : ''}
        >
          <option value="">Seleccione una opción ...</option>
          <option value="obralabor">Obra Labor</option>
          <option value="fijo">Fijo</option>
          <option value="indefinido">Indefinido</option>
        </select>
        {errors.tipoContrato && <span className="field-error">{errors.tipoContrato}</span>}
      </div>

      {/* LABOR DETERMINADA */}
      <div className="field-group">
        <label htmlFor="laborDeterminada">
          En caso de ser OBRA LABOR, especificar la LABOR DETERMINADA de contratación
          {formData.tipoContrato === 'obralabor' && <span className="required"> *</span>}
        </label>

        <textarea
          id="laborDeterminada"
          name="laborDeterminada"
          value={formData.laborDeterminada || ''}
          onChange={onChange}
          placeholder={formData.tipoContrato === 'obralabor' ? "Describa detalladamente la labor determinada (Obligatorio)..." : "No aplica para este tipo de contrato"}
          rows="5"
          disabled={formData.tipoContrato !== 'obralabor'}
          className={errors.laborDeterminada ? 'error-field' : ''}
        />
        {errors.laborDeterminada && <span className="field-error">{errors.laborDeterminada}</span>}
      </div>

      {/* SALARIO */}
      <div className="field-group">
        <label htmlFor="salario">
          Salario Mensual a Devengar <span className="required">*</span>
        </label>

        <input
          id="salario"
          name="salario"
          type="text"
          value={formData.salario ? `$ ${formatCurrency(formData.salario)}` : ''}
          onChange={onChange}
          placeholder="$ Ingrese el salario"
          className={errors.salario ? 'error-field' : ''}
        />

        {errors.salario && <span className="field-error">{errors.salario}</span>}
      </div>

      {/* FECHA INICIO */}
      <div className="field-group">
        <label htmlFor="fechainicio">
          Fecha de Inicio de Labores <span className="required">*</span>
        </label>
        <input
          id="fechainicio"
          name="fechainicio"
          type="date"
          value={formData.fechainicio}
          onChange={onChange}
          min={formatoFecha(fechaMin)}
          max={formatoFecha(fechaMax)}
          className={errors.fechainicio ? 'error-field' : ''}
        />
        {errors.fechainicio && (
          <span className="field-error">{errors.fechainicio}</span>
        )}
      </div>

      {/* OBSERVACIONES */}
      <div className="field-group">
        <label htmlFor="observaciones">
          Observaciones
        </label>

        <textarea
          id="observaciones"
          name="observaciones"
          value={formData.observaciones}
          onChange={onChange}
          placeholder="Ingrese observaciones..."
          rows="5"
        />
      </div>

    </div>
  );
}

export default Step7;